import React, {Component} from 'react';
import { Link } from "react-router-dom";
import CategoriesComponent from './CategoriesComponent';

class ViewAllDealsComponent extends Component{
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        const cat_id = typeof this.props.match.params.cat_id!=='undefined'  ? this.props.match.params.cat_id : ''
        return (
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="deals-tab-outer font-0 outer-glow1 mb-4 mx-auto">
                            <Link to={process.env.PUBLIC_URL+"/category/allday/view-all/"+cat_id} className="tabing-text">Per Person Deals</Link>
                            <Link to={process.env.PUBLIC_URL+"/category/oneday/view-all/"+cat_id} className="tabing-text grad-on">Group Deals</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 px--xs-0">
                            <div className="all-categories-outer">
                                <CategoriesComponent category_id={this.props.match.params.cat_id}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewAllDealsComponent;